/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HappeningCell_happening$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HappeningsContainer_lists$ref: FragmentReference;
declare export opaque type HappeningsContainer_lists$fragmentType: HappeningsContainer_lists$ref;
export type HappeningsContainer_lists = {|
  +heroOffers: {|
    +pageInfo: {|
      +hasNextPage: boolean,
      +endCursor: ?string,
    |},
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: HappeningCell_happening$ref,
      |}
    |}>,
  |},
  +$refType: HappeningsContainer_lists$ref,
|};
export type HappeningsContainer_lists$data = HappeningsContainer_lists;
export type HappeningsContainer_lists$key = {
  +$data?: HappeningsContainer_lists$data,
  +$fragmentRefs: HappeningsContainer_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startingAfter",
      "type": "DateTime"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endingBefore",
      "type": "DateTime"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "active",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "heroOffers"
        ]
      }
    ]
  },
  "name": "HappeningsContainer_lists",
  "selections": [
    {
      "alias": "heroOffers",
      "args": [
        {
          "kind": "Variable",
          "name": "active",
          "variableName": "active"
        },
        {
          "kind": "Variable",
          "name": "endingBefore",
          "variableName": "endingBefore"
        },
        {
          "kind": "Variable",
          "name": "startingAfter",
          "variableName": "startingAfter"
        }
      ],
      "concreteType": "HeroOfferConnection",
      "kind": "LinkedField",
      "name": "__HappeningsContainer_heroOffers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HeroOfferEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HeroOffer",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HappeningCell_happening"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '564c4524347e5dfe2fb8d35142961edb';

module.exports = node;
